import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import backgroundImage from "../../assets/images/BG1.jpg";
import logoImage from "../../assets/images/Red-Rhino-Logo.png";
import tickImage from "../../assets/images/Tick.png";
import { styles } from "../loginScreen/LoginScreen.styles";
import useIsMobile from "../../common/mobileVersion/useIsMobile";

const PasswordResetConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get passed state from navigation
  const isMobile = useIsMobile();
  const [orgId, setOrgId] = useState("");
  const [title, setTitle] = useState("Successful");
  const [description, setDescription] = useState(
    "Your password has been reset successfully."
  );
  const [isForgotPasswordFlow, setisForgotPasswordFlow] = useState(
    location.state?.isForgotPasswordFlow ?? true
  );

  useEffect(() => {
    const Organization = localStorage.getItem("orgId") ?? "";
    setOrgId(Organization);
    console.log(location.state);

    // Check if custom state exists
    if (location.state?.title) setTitle(location.state.title);
    if (location.state?.description) setDescription(location.state.description);
    if (location.state?.isForgotPasswordFlow)
      setisForgotPasswordFlow(location.state.isForgotPasswordFlow);
  }, [location.state]);

  const handleContinue = () => {
    navigate(`/${orgId}`);
  };

  const commonTextStyles = {
    textAlign: "center",
    marginBottom: 2,
  };
  return (
    <Box sx={styles.container(backgroundImage)}>
      <Box sx={styles.logoContainer(isMobile)}>
        <Box
          component="img"
          src={logoImage}
          alt="Logo"
          sx={styles.logo(isMobile)}
        />
      </Box>
      <Box sx={{ ...styles.formContainer(isMobile), alignItems: "center" }}>
        <img
          src={tickImage}
          alt="Success"
          style={{ width: 100, height: 100, marginBottom: 16 }}
        />

        {/* Dynamic Title */}
        {isForgotPasswordFlow && (
          <Typography variant="h2" gutterBottom sx={commonTextStyles}>
            {title}
          </Typography>
        )}

        {/* Dynamic Description */}
        {isForgotPasswordFlow && (
          <Typography
            variant="subtitle2"
            gutterBottom
            color="gray"
            sx={commonTextStyles}
          >
            {description}
          </Typography>
        )}

        {!isForgotPasswordFlow && (
          <Typography
            variant="subtitle2"
            gutterBottom
            color="#333333"
            sx={commonTextStyles}
          >
            {description}
          </Typography>
        )}

        {isForgotPasswordFlow && (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleContinue}
            sx={{ ...styles.loginButton(isMobile) }}
          >
            CONTINUE
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PasswordResetConfirmation;
